import { observer } from "mobx-react-lite";
import { useFontDesk } from "../../context/frontDeskContext";
import TopBar from "../../components/topBar/TopBar";
import { isMobile } from "react-device-detect";
import { Strings } from "../../utils/strings";
import { CustomDialog } from "../../components/dialog/CustomDialog";
import {
  useCreateLeagueMatchStore,
  useNationalLeagueStore,
} from "../../store/StoreContext";
import LoadingIndicator from "../../components/loadingIndicator/LoadingIndicator";
import { SelectDateAndTime } from "./widgets/SelectDateTime";
import { SelectCountries } from "./widgets/SelectCountries";
import { useRef, useEffect } from "react";
import { Button } from "../../components/button/Button";
import { Colors } from "../../utils/colors";
import { useNavigate } from "react-router-dom";
import { SelectLocation } from "./widgets/SelectLocation";

const CreateLeagueMatch = observer(() => {
  const { onLogOut } = useFontDesk();
  const createLeagueMatchStore = useCreateLeagueMatchStore();
  const nationalLeagueStore = useNationalLeagueStore();
  const navigate = useNavigate();

  const hasFetched = useRef(false);

  useEffect(() => {
    if (!hasFetched.current) {
      createLeagueMatchStore.getAllCountries();
      createLeagueMatchStore.reset();
      hasFetched.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      style={{
        paddingBottom: 30,
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        position: "relative", // Added for positioning the FAB
        marginTop: 80,
        overflowAnchor: "none",
      }}>
      <TopBar
        isBack={isMobile}
        onLogout={() => {
          createLeagueMatchStore.modalData = {
            visible: true,
            title: Strings.LOGOUT,
            children: Strings.LOGOUT_WARNING,
            btnText: Strings.LOGOUT,
            btnVariant: "outline-danger",
            headerIcon: <div />,
            onClose: () => {
              createLeagueMatchStore.modalData = undefined;
            },
            onAccept: () => {
              createLeagueMatchStore.modalData = undefined;
              onLogOut();
            },
          };
        }}
      />
      <div
        style={{
          maxWidth: "450px",
          width: "100%",
          justifyContent: "center",
          alignSelf: "center",
          margin: "0 auto",
        }}>
        <SelectCountries />
        <div style={{ height: 20 }} />
        <SelectLocation />
        <div style={{ height: 20 }} />
        <SelectDateAndTime />
        <Button
          disabled={createLeagueMatchStore.isButtonDisabled()}
          text="Create Match"
          onPress={async () => {
            createLeagueMatchStore.postLeagueMatch(
              nationalLeagueStore.leagueId ?? 0,
              () => navigate(-1)
            );
          }}
          btnStyle={{
            paddingLeft: 40,
            paddingRight: 40,
            height: 50,
            backgroundColor: Colors.darkBrown,
            width: "100%",
            marginTop: 20,
            marginBottom: 30,
          }}
          textStyle={{
            color: "white",
            fontWeight: 600,
            fontSize: 14,
          }}
        />
      </div>
      <CustomDialog
        visible={createLeagueMatchStore.modalData?.visible ?? false}
        title={createLeagueMatchStore.modalData?.title ?? ""}
        description={createLeagueMatchStore.modalData?.children ?? ""}
        onCancel={createLeagueMatchStore.modalData?.onClose}
        onConfirm={createLeagueMatchStore.modalData?.onAccept}
      />
      <LoadingIndicator loading={createLeagueMatchStore.isLoading} />
    </div>
  );
});

export default CreateLeagueMatch;
